import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=62df8c3e&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=62df8c3e&prod&scoped=true&lang=css"
import style1 from "./ChatMessage.vue?vue&type=style&index=1&id=62df8c3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62df8c3e",
  null
  
)

export default component.exports